<h2 mat-dialog-title id="gruppe-møtedeltakelse-eksport-dialog-tittel">{{ "Møtedeltakelse"|translate }}</h2>
<mat-dialog-content class="skjema">
  <p>{{'Velg perioden du ønsker oversikt over møtedeltakelse for.'|translate}}</p>
  <mat-form-field>
    <mat-label>{{'Periode'|translate}}</mat-label>
    <mat-date-range-input [formGroup]="skjema" [rangePicker]="picker">
      <input matStartDate [formControl]="skjema.controls.fraOgMed" placeholder="{{'Fra og med'|translate}}">
      <input matEndDate [formControl]="skjema.controls.tilOgMed" placeholder="{{'Til og med'|translate}}">
    </mat-date-range-input>
    <mat-hint><mat-datoformat/> – <mat-datoformat/></mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
    @if (skjema.controls.fraOgMed.hasError('matDatepickerParse') ||
    skjema.controls.tilOgMed.hasError('matDatepickerParse')) {
      <mat-error>
        {{ skjema.controls.fraOgMed.errors | standardvalideringsfeil:'matDatepickerParse' }}
        {{ skjema.controls.tilOgMed.errors | standardvalideringsfeil:'matDatepickerParse' }}
      </mat-error>
    }
    @if (skjema.controls.fraOgMed.hasError('matStartDateInvalid') ||
    skjema.controls.tilOgMed.hasError('matEndDateInvalid')) {
      <mat-error>{{ 'Start må være før slutt'|translate }}</mat-error>
    }
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
  <button mat-raised-button color="primary" type="button" (click)="lastNed()" [disabled]="genererer() || skjema.invalid"
          [visSpinner]="genererer()" spinnerTekst="{{'Generer rapport...'|translate}}">
    {{ "Last ned Excel fil"|translate }}
  </button>
</mat-dialog-actions>
